import { faX } from "@fortawesome/pro-regular-svg-icons";
import { faListUl } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Drawer, IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { useGetAllMaps } from "src/api/map";
import { MapContext } from "src/contexts/map";

import MobileFilterElements from "./MobileFilterElements";
import MobileLayersList from "./MobileLayerList";

export type Type_Props_Mobile_View_Drawer = {
    closeDrawer: () => void;
};

const MobileViewDrawer = () => {
    const { data, isLoading } = useGetAllMaps();
    const { updateSelectedMap, updateMaps } = useContext(MapContext);

    const [openDrawer, setOpenDrawer] = useState(false);

    useEffect(() => {
        if (!isLoading) {
            updateMaps(data);
            updateSelectedMap(data[0]);
        }
    }, [isLoading]);

    const closeDrawer = () => setOpenDrawer(false);

    return (
        <>
            <IconButton onClick={() => setOpenDrawer(true)}>
                <FontAwesomeIcon icon={faListUl} />
            </IconButton>
            <Drawer open={openDrawer} onClose={() => closeDrawer()}>
                <Box
                    m={2}
                    component="span"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Box component="img" src="/static/images/logo.svg" />
                    <FontAwesomeIcon icon={faX} onClick={() => closeDrawer()} />
                </Box>
                <MobileLayersList closeDrawer={() => closeDrawer()} />
                <MobileFilterElements closeDrawer={() => closeDrawer()} />
            </Drawer>
        </>
    );
};

export default MobileViewDrawer;
